/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datenschutzerklaerungerhalten1Inputs */

const de__field_datenschutzerklaerungerhalten1 = /** @type {(inputs: _Field_Datenschutzerklaerungerhalten1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung erhalten`)
};

/**

* @param {_Field_Datenschutzerklaerungerhalten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datenschutzerklaerungerhalten1 = /** @type {((inputs?: _Field_Datenschutzerklaerungerhalten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datenschutzerklaerungerhalten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datenschutzerklaerungerhalten1(inputs)
});
export { _field_datenschutzerklaerungerhalten1 as "_field_datenschutzerklaerungErhalten" }